import { Table, Space, Button, Popconfirm, Tag } from 'antd';

export default function MethodList({ methods = [], onEdit, onDelete }) {
    const columns = [
        {
            title: 'Tên phương thức',
            dataIndex: 'methodName',
            key: 'methodName',
        },
        {
            title: 'HTTP',
            dataIndex: 'httpMethod',
            key: 'httpMethod',
            render: method => <Tag color="blue">{method}</Tag>
        },
        {
            title: 'Đối tác',
            dataIndex: 'partnerId',
            key: 'partnerId',
            render: id => <Tag color="geekblue">{id}</Tag>
        },
        {
            title: 'Schema',
            dataIndex: 'schemaId',
            key: 'schemaId',
            render: id => <Tag color="purple">{id}</Tag>
        },
        {
            title: 'Loại sự kiện',
            dataIndex: 'eventType',
            key: 'eventType',
        },
        {
            title: 'Chiều dữ liệu',
            dataIndex: 'direction',
            key: 'direction',
        },
        {
            title: 'Hành động',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button type="link" onClick={() => onEdit(record)}>Sửa</Button>
                    <Popconfirm
                        title="Bạn có chắc muốn xoá không?"
                        onConfirm={() => onDelete(record)}
                        okText="Xoá"
                        cancelText="Huỷ"
                    >
                        <Button type="link" danger>Xoá</Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    const dataSource = methods.map((m, i) => ({
        key: m.id || i,
        ...m,
    }));

    return (
        <Table
            dataSource={dataSource}
            columns={columns}
            bordered
            pagination={{ pageSize: 10 }}
        />
    );
}
